import { HeartIcon } from '@heroicons/react/solid'
import MatchedWordsImage from '../matchedwords.png'

export interface Plan {
  title: string
  external_id: string // alphanumeric string
  external_num: number
  description: JSX.Element
  price: number // in cents
}

const featureItem = (title: string, heartFill: string, description?: JSX.Element) => {
  return <li className="py-1 flex flex-col">
    <div className="flex items-center">
      <HeartIcon className={`${heartFill} h-6 w-6 mr-3 scale-up cursor-pointer inline`} />
      <strong className="mr-2 text-lg">{title}</strong>
    </div>
    {description && <div>{description}</div>}</li>
}

export const POLYGONLE_PLUS: Plan = {
    title: 'Polygonle+',
    external_id: process.env.REACT_APP_XSOLLA_POLYGONLE_PLUS_PLAN_ID!,
    external_num: Number(process.env.REACT_APP_XSOLLA_POLYGONLE_PLUS_PLAN_NUM!),
    price: 399,
    description: (
      <>
        <p className="mt-2">Thanks for playing my game! Subscribers get these cool features:</p>
        <ul className="text-start p-2">
          {featureItem('No ads', 'fill-[#FF407B]')}
          {featureItem('Statistics backup', 'fill-[#FD8C44]', <>Your game stats are backed up to the cloud. Play on any device and keep your stats in-sync.</>)}
          {featureItem('Extra goodies', 'fill-[#FEC04F]', <>See a detailed breakdown of words which matched each puzzle.<img className="my-2 w-96 border-4" src={MatchedWordsImage} alt="archive" /></>)}
          {featureItem('Support us', 'fill-[#3E90DE]', <>Help me cover the costs of hosting and developing new features.</>)}
        </ul>
        <p>Join Polygonle+ with a <strong>7 day free trial</strong></p>
        <p>Cancel anytime!</p>
      </>
    ),
}

export const PLANS: Plan[] = [
  POLYGONLE_PLUS
]

export const planNumToPlanId = new Map(PLANS.map((p) => [p.external_num, p.external_id]))

export const getPlanById = (id: string): Plan => {
  const plan = PLANS.find((p) => p.external_id === id)
  if(!plan) {
    throw new Error(`no plan with id: ${id}`)
  }
  return plan
}

export function hasPolygonlePlus(p: Plan|null): boolean {
  return Boolean(p) && (p!.external_id === POLYGONLE_PLUS.external_id)
}
